import React from "react"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { metadataSelector } from "store/selectors"
import StatCard from "./StatCard"
import { getDateLabel } from "./utils/dateLabels"

TotalBookingValue.propTypes = {
  params: PropTypes.shape({
    overview_range: PropTypes.string.isRequired,
    date_gteq: PropTypes.string,
    date_lteq: PropTypes.string
  }).isRequired
}

export default function TotalBookingValue({ params }) {
  const { t } = useTranslation()
  const { bookings_stats, booking_client_stats, date_range } = useSelector(metadataSelector("accounting"))
  const dates = getDateLabel(params, date_range?.label)
  const { new_client_count = 0, recurring_client_count = 0 } = booking_client_stats?.[params.overview_range] || {}

  const tooltip = (
    <>
      {t("accounting.labels.total_booking_value_tooltip_new", { clients: new_client_count })}
      <br />
      {t("accounting.labels.total_booking_value_tooltip_recurring", { recurringClients: recurring_client_count })}
    </>
  )

  return (
    <StatCard
      title={t("accounting.labels.total_booking")}
      tooltip={tooltip}
      dates={dates}
      value={bookings_stats?.[params.overview_range]}
      monthlyDiff={bookings_stats?.monthly_diff}
      isCurrentMonth={params.overview_range === "current_month"}
    />
  )
}
